import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";

export class memberForgotPw {
	private forgotPwForm:any   = $('#member-forgotpw-form');
	private memberBase:any = new memberPortal();

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): any {
		let _self = this;
		let inputElArr:any = $.makeArray(_self.forgotPwForm.find('input[type="text"], input[type="email"], input[type="password"]'));

		_self.memberBase.initFormTextInputs(inputElArr);
	}

	validateForm(): any {
		let _self = this;

		_self.memberBase.validateForm(_self.forgotPwForm,
			function(validation: any) {
				// all your custom validation here
			},
			function(validation:any, formData:any) {
				// on success function
				// window.location = window.location.origin + '/members/register-success.html';
				var submitBtn = _self.forgotPwForm.find('#member-forgotpw-form--submit');
				var successMsg = _self.forgotPwForm.parents().eq(1).find('#password-change-success');
				successMsg.attr({'style': 'width: auto'});

				submitBtn.fadeOut();
				successMsg.fadeIn();
			});
	}

}

let scope:Element = document.querySelector('#member-forgotpw-form');

if (scope) {
	try {
	let memberforgotpw = new memberForgotPw();
	memberforgotpw.initTextInputs();
	memberforgotpw.validateForm();
	} catch(e) {console.error(e);}
}
